module.exports = __webpack_public_path__ + "img/Norte.2e9e50df.svg";